module.exports = __webpack_public_path__ + "static/media/Nokia 230 Black.97735e1b.png";